<template>
  <div
    class="profile-page !p-4 lg:p-[30px] !box-border !bg-container-background !rounded-[16px] heightClass overflow-y-auto"
  >
    <el-row :gutter="30">
      <el-col :lg="6" :md="8" :sm="24">
        <div
          class="profile-card text-center !shadow-none !rounded-[16px]"
          shadow="never"
          style="margin-bottom: 20px"
        >
          <div class="profile-container my-3">
            <el-tooltip
              :content="
                getUserProfilePicture && getUserProfilePicture.length > 20
                  ? 'Update Profile Picture'
                  : 'Add Profile Picture'
              "
            >
              <div class="profile-wrapper">
                <img
                  v-if="getUserProfilePicture && getUserProfilePicture.length > 20"
                  :src="getUserProfilePicture"
                  alt="Avatar"
                  width="120"
                  class="profile-image"
                  @click="outerVisible = true"
                />
                <img
                  v-else
                  src="@/assets/img/avatar.svg"
                  alt="Avatar"
                  width="120"
                  class="profile-image"
                  @click="outerVisible = true"
                />

                <el-button
                  v-if="getUserProfilePicture && getUserProfilePicture.length > 20"
                  class="delete-button"
                  type="plain"
                  size="mini"
                  circle
                  @click="deleteProfile()"
                >
                  <img width="12px" src="@/assets/Trash.svg" />
                </el-button>
              </div>
            </el-tooltip>
          </div>
          <hr />

          <div
            class="list-group text-left !px-[15px] !pb-4 max-h-[calc(100vh-330px)] overflow-y-auto"
            id="profileList"
          >
            <span :class="getClass('personal-information')" @click="goTo('personal-information')">
              <img
                src="@/assets/img/sideMenu/inactive_icons/profile.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Personal Information
            </span>
            <span :class="getClass('change-password')" @click="goTo('change-password')">
              <img
                src="@/assets/img/sideMenu/inactive_icons/change-password.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Change Password
            </span>
            <span :class="getClass('two-step-verification')" @click="goTo('two-step-verification')">
              <img
                src="@/assets/img/sideMenu/inactive_icons/two-step-verification.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Two-Step Verification
            </span>
            <span :class="getClass('signature')" @click="goTo('signature')">
              <img
                src="@/assets/img/sideMenu/inactive_icons/signature.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Signature
            </span>
            <span
              v-if="
                (getActiveWorkspace &&
                  getActiveWorkspace.company_id &&
                  getUserType &&
                  this.isOwner()) ||
                this.isIndividualWorkspace
              "
              :class="getClass('subscription')"
              @click="goTo('subscription')"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/subscription.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Subscription
            </span>
            <span
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                (((this.isAdmin() || this.isOwner()) && !this.isIndividualWorkspace) ||
                  checkIsSuperAdminOrNotForProfileManagementPermissions('companyProfile'))
              "
              :class="getClass('companyProfile')"
              @click="goTo('companyProfile')"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/company-profile.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Company Profile
            </span>
            <span
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                !this.isIndividualWorkspace &&
                ((getUserType.name && this.isOwner() && this.isWorkspaceIsBusiness) ||
                  checkIsSuperAdminOrNotForProfileManagementPermissions('managePermissions'))
              "
              :class="getClass('manage-permissions')"
              @click="goTo('manage-permissions')"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/manage-permission.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Manage Permissions
            </span>
            <span
              :class="getClass('menuManagement')"
              @click="goTo('/menu-management', true)"
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                !this.isIndividualWorkspace &&
                ((getUserType.name && this.isOwner() && this.isWorkspaceIsBusiness) ||
                  checkIsSuperAdminOrNotForProfileManagementPermissions('menuManagement'))
              "
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/menu-mangement.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />

              Menu Management
            </span>
            <span
              :class="getClass('menuManagement')"
              @click="goTo('/roles', true)"
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                !this.isIndividualWorkspace &&
                ((getUserType.name && this.isOwner() && this.isWorkspaceIsBusiness) ||
                  checkIsSuperAdminOrNotForProfileManagementPermissions('roleManagement'))
              "
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/role-mangement.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />

              Role Management
            </span>
            <span
              :class="getClass('GlobalSettings')"
              @click="goTo('/profile/GlobalSettings', true)"
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                !this.isIndividualWorkspace &&
                ((getUserType.name && this.isOwner() && this.isWorkspaceIsBusiness) ||
                  checkIsSuperAdminOrNotForProfileManagementPermissions('GlobalSettings'))
              "
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/global-settings.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />

              Global settings
            </span>
            <span
              :class="getClass('remove-workspace')"
              @click="goTo('remove-workspace')"
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                !this.isIndividualWorkspace &&
                getUserType.name &&
                this.isOwner() &&
                this.isWorkspaceIsBusiness
              "
            >
              <i class="el-icon-user"></i>

              Remove Workspace
            </span>
            <span :class="getClass('theme-setup')" @click="goTo('theme-setup')">
              <img
                src="@/assets/img/sideMenu/inactive_icons/theme-setup.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />

              Theme Setup
            </span>
            <span
              :class="getClass('export-or-import-application')"
              @click="goTo('export-or-import-application')"
              v-if="
                getActiveWorkspace &&
                getActiveWorkspace.company_id &&
                getUserType &&
                !this.isIndividualWorkspace &&
                getUserType.name &&
                this.isOwner() &&
                this.isWorkspaceIsBusiness &&
                !this.getAppMode
              "
            >
              <i class="el-icon-upload"></i>

              Export or Import Application
            </span>
          </div>
        </div>
      </el-col>
      <el-col :lg="18" :md="16" :sm="24">
        <!-- {{this.isOwner()}} -->
        <component :is="layout">
          <router-view :layout.sync="layout" />
        </component>
      </el-col>
    </el-row>
    <dialog-component
      id="profileUploadDialog"
      :width="getIsMobile ? '100%' : '100%'"
      :height="getIsMobile ? '100%' : '100%'"
      :title="'Update Profile Picture'"
      :visible="outerVisible"
      @before-close="closeDialog"
    >
      <vue-anka-cropper
        class="upload-file"
        :options="{
          aspectRatio: false,
          closeOnSave: true,
          cropArea: 'circle',
          croppedHeight: 1000,
          croppedWidth: 1000,
          cropperHeight: false,
          dropareaMessage: ' Drag & Drop  file here or use the button below.',
          frameLineDash: [1, 1000],
          frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
          handleFillColor: 'rgba(255, 255, 255, 0.2)',
          handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
          handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
          handleSize: 5,
          handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
          layoutBreakpoint: 40,
          maxCropperHeight: 1000,
          maxFileSize: 8000000,
          overlayFill: 'rgba(0, 0, 0, 0.5)',
          previewOnDrag: true,
          previewQuality: 0.65,
          resultQuality: 0.8,
          resultMimeType: 'image/jpeg',
          resultMimeType: 'image/png',
          resultMimeType: 'image/jpg',
          resultMimeType: 'image/gif',
          selectButtonLabel: 'Select File Supported : JPG, PNG, JPEG, GIF',
          showPreview: true,
          skin: 'light',
          uploadData: {},
          uploadTo: false,
        }"
        name="logo"
        @cropper-error="fileError"
        @cropper-preview="uploadFile"
        @cropper-file-selected="uploadFile"
        @cropper-saved="onUpdate"
        v-loading="upLoadEffect"
        accept="image/jpeg,image/png,image/jpg,image/gif"
      ></vue-anka-cropper>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="bg-transparent !px-3 !py-1 !rounded-md !text-xs 2xl:!text-sm !border !border-red-500 hover:border hover:!border-brand-500 hover:text-brand-500 !border-none"
          @click="
            outerVisible = false;
            resetImgData();
          "
          plain
        >
          Cancel
        </el-button>
        <el-button
          style="background: var(--brand-500) !important"
          class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:!text-sm"
          type="button"
          @click="onUpdate()"
        >
          Save
        </el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';

  import PermissionsHelper from '@/mixins/permissionsHelper';
  import vueAnkaCropper from 'vue-anka-cropper';
  import 'vue-anka-cropper/dist/VueAnkaCropper.css';
  export default {
    name: 'ProfileBody',
    data() {
      return {
        layout: 'div',
        outerVisible: false,
        imgData: '',
        previewImage: '',
        profileData: null,
        upLoadEffect: false,
        buttondisale: true,
        planDetails: {},
      };
    },

    mixins: [MobileRelatedHelper, PermissionsHelper],

    mounted() {
      this.getUserSavedProfilePicture();
      this.getSubscriptionHistory();
      this.replaceSvgImages(); // 👈 Call method after DOM is ready
    },
    computed: {
      ...mapGetters('auth', [
        'getUpdateProfilePicStatus',
        'getupdateprofilepicture',
        'getActiveWorkspace',
        'getUserType',
        'getAppMode',
      ]),
      ...mapGetters('navigationOpen', ['getIsMobile']),
      ...mapGetters('paymentGateway', ['getPaymentsHistory', 'getPlansFeatures']),
      getUserProfilePicture() {
        if (this.getupdateprofilepicture) {
          return this.getupdateprofilepicture;
        } else {
          return null;
        }
      },
      getClass() {
        return (routeName) => {
          if (routeName == this.$route.name) {
            return 'list-group-item list-group-item-action active';
          } else return 'list-group-item list-group-item-action';
        };
      },
    },
    components: { vueAnkaCropper },

    methods: {
      closeDialog() {
        this.outerVisible = false;
      },

      async getSubscriptionHistory() {
        try {
          this.loading = true;
          let email = '';
          await this.$store.dispatch('paymentGateway/fetchSubscriptionInfo', {
            email,
          });
          if (
            this.getPaymentsHistory &&
            this.getPaymentsHistory.planFeatures &&
            this.getPaymentsHistory.planFeatures.length
          ) {
            this.planDetails =
              this.getPaymentsHistory &&
              this.getPaymentsHistory.planFeatures &&
              this.getPaymentsHistory.planFeatures[0];
          }
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        } catch (error) {
          this.loading = false;
          console.log('getSubscriptionHistory', error);
        }
      },

      goTo(componentName, status = false) {
        let allowedRoutes = [
          'personal-information',
          'change-password',
          'signature',
          'subscription',
          'remove-workspace',
          'theme-setup',
          'export-or-import-application',
        ];
        console.log('allowedRoutes.indexOf(componentName)', allowedRoutes.indexOf(componentName));
        if (this.planDetails.diff || allowedRoutes.indexOf(componentName) >= 0) {
          if (status) {
            this.$router.push({
              path: componentName,
              query: {
                key: Math.floor(Math.random() * 100000),
              },
            });
          } else {
            this.$router.push({
              name: componentName,
              query: {
                key: Math.floor(Math.random() * 100000),
              },
            });
          }
        } else {
          this.$message({
            message: 'Your package has expired.',
            type: 'error',
          });
        }
      },

      resetImgData() {
        this.imgData = '';
      },
      async deleteProfile() {
        this.$confirm('Are you sure you want to delete the profile picture?')
          .then(async () => {
            let params = {
              file: '',
              isRemovingProfilePicture: true,
            };
            await this.$store.dispatch('auth/fetchupdateProfilePicStatus', params);
            if (this.getUpdateProfilePicStatus) {
              this.resetImgData();
              this.$notify({
                title: 'Success',
                message: 'Profile picture deleted successfully.',
                type: 'success',
              });
              window.location.reload();
            } else {
              this.$notify({
                title: 'Error',
                message: 'Error in deleting profile',
                type: 'error',
              });
            }
          })
          .catch(() => {});
      },
      async onUpdate() {
        this.upLoadEffect = true;
        let params = {
          file: this.imgData,
        };
        await this.$store.dispatch('auth/fetchupdateProfilePicStatus', params);
        if (this.getUpdateProfilePicStatus) {
          this.$notify({
            title: 'Success',
            message: 'Profile Picture Updated Successfully',
            type: 'success',
          });
          this.outerVisible = false;
          this.upLoadEffect = false;
          this.buttondisale = true;
        } else {
          this.$notify({
            title: 'Error',
            message: 'Error while updating profile',
            type: 'error',
          });
          this.upLoadEffect = false;
          this.buttondisale = true;
        }
      },
      async getUserSavedProfilePicture() {
        await this.$store.dispatch('auth/fetchupdateProfilePicture');
      },
      fileError() {
        this.$alert('Maximum Upload file size: 8 MB');
      },
      uploadFile(file) {
        this.imgData = file;
        this.profileData = file;
        setTimeout(() => {
          const doc = document.querySelector('.ankaCropper__previewArea');
          this.imgData = doc.querySelector('img').src;
        }, 1000);
      },

      getBase64(file) {
        return new Promise(function (resolve, reject) {
          let reader = new FileReader();
          let imgResult = '';
          reader.readAsDataURL(file);
          reader.onload = function () {
            imgResult = reader.result;
          };
          reader.onerror = function (error) {
            reject(error);
          };
          reader.onloadend = function () {
            resolve(imgResult);
          };
        });
      },
      replaceSvgImages() {
        document.querySelectorAll('img.svg').forEach((img) => {
          const imgID = img.id;
          const imgClass = img.className;
          const imgURL = img.getAttribute('src');

          fetch(imgURL)
            .then((response) => response.text())
            .then((data) => {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(data, 'image/svg+xml');
              const svg = xmlDoc.querySelector('svg');
              if (!svg) return;

              if (imgID) svg.setAttribute('id', imgID);
              if (imgClass) svg.setAttribute('class', `${imgClass} replaced-svg`);
              svg.removeAttribute('xmlns:a');

              for (let attr of img.attributes) {
                if (!['src', 'class', 'id'].includes(attr.name)) {
                  svg.setAttribute(attr.name, attr.value);
                }
              }

              img.replaceWith(svg);
            })
            .catch((err) => {
              console.error(`Error loading SVG from ${imgURL}:`, err);
            });
        });
      },
    },
  };
  // Changes Img to SVG
  document.querySelectorAll('img.svg').forEach((img) => {
    const imgID = img.id;
    const imgClass = img.className;
    const imgURL = img.getAttribute('src');

    fetch(imgURL)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, 'image/svg+xml');
        const svg = xmlDoc.querySelector('svg');

        if (!svg) return;

        // Set ID and classes
        if (imgID) svg.setAttribute('id', imgID);
        if (imgClass) svg.setAttribute('class', `${imgClass} replaced-svg`);

        // Remove any invalid XML namespace
        svg.removeAttribute('xmlns:a');

        // Copy all image attributes (optional)
        for (let attr of img.attributes) {
          if (!['src', 'class', 'id'].includes(attr.name)) {
            svg.setAttribute(attr.name, attr.value);
          }
        }

        // Replace the <img> with the inline <svg>
        img.replaceWith(svg);
      })
      .catch((err) => {
        console.error(`Error loading SVG from ${imgURL}:`, err);
      });
  });
</script>

<style lang="scss" scoped>
  .profile-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .profile-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .profile-image {
    border-radius: 50%;
    display: block;
  }

  .delete-button {
    position: absolute;
    bottom: 5px;
    left: 73%;
    transform: translateX(-50%);
    background-color: ivory;
    padding: 4px;
    border-radius: 50%;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  }

  .ankaCropper__navigation a:nth-child(4n + 4) {
    display: none !important;
  }

  .ankaCropper__navigation a:nth-child(5n + 5) {
    display: none !important;
  }

  .cropper {
    height: 600px;
    width: 600px;
    background: #ddd;
  }

  .profile-page {
    .profile-card {
      border-radius: 4px;
      border: 1px solid var(--card-border);
      margin: 0 -1px;
      transform: scale(1);

      .list-group {
        max-width: 100% !important;

        .list-group-item {
          border-radius: 0px 6px 6px 0px;
          padding: 1em;
          border: none;
          color: var(--black-600);
          cursor: pointer;

          [class^='el-icon'] {
            margin-right: 10px;
          }

          &.active {
            svg {
              path {
                fill: var(--brand-500) !important;
                stroke: var(--brand-500) !important;
              }
            }
          }
        }
      }
    }
  }

  .profile-card {
    transition: transform 0.5s ease-in-out;
    transition: box-shadow 0.5s ease-in-out;
  }

  .el-button.is-plain:hover {
    background: var(--primary-contrast-color);
    border-color: var(--primary-color-brand);
    color: var(--primary-color-brand);
  }

  .el-button--text,
  .el-button--text:hover {
    border: none !important;
  }
</style>
<style></style>
